import PharmacistPromoCode from './PharmacistPromoCode';

export default PharmacistPromoCode;
